<template>
  <div class="common-use">
    <navbar :title="storeInfo.shoptitle" left-text show-home></navbar>
    <div class="store-header">
      <div class="store-icon van-hairline--surround" v-if="storeInfo.shopicon">
        <img :src="storeInfo.shopicon.url" />
      </div>
      <div class="store-intro" v-if="storeInfo.shoptitle">
        <span class="name">{{storeInfo.shoptitle}}</span>
        <span class="total-goods">共有 {{totalCont}} 款商品</span>
      </div>
    </div>
    <div class="common-use-wrapper" v-show="storeList.length ">
      <van-list :finished="finished" @load="onLoad" finished-text="没有更多了" v-model="loading">
        <div class="product-list">
          <product-list :sku-list="storeList"></product-list>
        </div>
      </van-list>
    </div>
    <div class="no-data" v-show="noData && !storeList.length">
      <img src="../../assets/img/nodata.png" />
      <p>商品进货中…</p>
    </div>
  </div>
</template>

<script>
import { List } from 'vant'
import Navbar from '../../components/NavBar'
import ProductList from '../../components/ProductDoubleEach'
let flag = false
export default {
  name: 'commonUse',
  components: {
    Navbar,
    VanList: List,
    ProductList
  },
  data () {
    return {
      storeInfo: {},
      storeList: [],
      storeListLeft: [],
      storeListRight: [],
      loading: false,
      finished: false,
      pageNum: 1,
      totalCont: 0,
      componentId: null,
      noData: false
    }
  },

  created () {
    this.$toast.loading({
      message: '正在加载...',
      duration: 300000
    })
    this.getStoreInfo(this.$route.query)
    this.cid = this.$route.query.column
    this.getStoreList(this.pageNum)
  },
  methods: {
    onLoad () {
      if (flag) {
        return
      }
      flag = true
      setTimeout(() => {
        this.getStoreList(++this.pageNum).then(() => {
          setTimeout(() => {
            this.loading = false
            flag = false
          }, 1000)
        })
      }, 500)
    },

    /**
     * 获取店铺信息
     */
    async getStoreInfo (storeInfo) {
      const res = await this.$axios.get(
        `api/goods/channel/${storeInfo.column}`
      )
      if (res.status === 200) {
        const { code, data, msg } = res.data
        if (code === 0) {
          this.storeInfo = data.template_elements
        } else {
          this.$toast(msg)
        }
      }
    },

    /**
     * 获取店铺商品类表
     */
    async getStoreList (pageNum) {
      const res = await this.$axios.get(
        `/api/goods/channelItems/${this.cid}/${pageNum}`
      )
      if (res.status === 200) {
        this.$toast.clear()
        const { code, data, msg, count } = res.data
        if (code === 0) {
          this.totalCont = count
          this.storeList = [...this.storeList, ...data]
        } else if (code === 9006) {
          this.finished = true
          if (pageNum === 1) {
            this.noData = true
          }
        } else {
          this.$toast(msg)
        }
      }
    }
  },
  activated () {
    if (this.cid !== this.$route.query.column) {
      this.cid = this.$route.query.column
      this.storeInfo = {}
      this.pageNum = 1
      this.noData = false
      this.finished = false
      this.storeList = []
      this.totalCont = 0
      this.storeListLeft = []
      this.storeListRight = []
      this.$toast.loading({
        message: '正在加载...',
        duration: 300000
      })
      this.getStoreList(this.pageNum)
      this.getStoreInfo(this.$route.query)
    }
  }
}
</script>

<style lang="less" scoped>
.common-use {
}
.store-header {
  padding: 0 0.2rem;
  height: 1.34rem;
  background-color: #fff;
  display: flex;
  align-items: center;
  border-bottom: 0.5px solid #d9d9d9;
  .store-icon {
    width: 2.27rem;
    height: 0.96rem;
    margin-right: 0.25rem;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
  .store-intro {
    .flex-column;
    .name {
      font-size: @fz28;
      font-weight: bold;
    }
  }

  .total-goods {
    font-size: @fz24;
  }
}
.product-list {
  padding: 0 0.2rem 0.2rem;
  display: flex;
  justify-content: space-between;
}
.no-data {
  width: 2.68rem;
  height: 2.53rem;
  margin: 0 auto;
  padding-top: 2.33rem;
  font-size: @fz28;
  color: @c80;
  text-align: center;
  p {
    padding-top: 0.24rem;
  }
}
</style>
